import { TablePagination } from "@mui/material";
import { GridPaginationModel } from "@mui/x-data-grid";

interface TablePaginationProps {
  paginationModel: GridPaginationModel;
  onPaginationModelChange: React.Dispatch<
    React.SetStateAction<GridPaginationModel>
  >;
  rowCount: number;
}

const CustomTablePagination = ({
  paginationModel,
  onPaginationModelChange,
  rowCount,
}: TablePaginationProps) => {
  return (
    <TablePagination
      component="div"
      count={rowCount}
      page={paginationModel.page}
      onPageChange={(_, newPage) => {
        onPaginationModelChange({
          page: newPage,
          pageSize: paginationModel.pageSize,
        });
      }}
      rowsPerPage={paginationModel.pageSize}
      onRowsPerPageChange={(event) => {
        onPaginationModelChange({
          page: paginationModel.page,
          pageSize: parseInt(event.target.value, 10),
        });
      }}
    />
  );
};

export default CustomTablePagination;
